import ProConnectLanding from './pages/ProConnectLanding';
import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';
import NotFound from './pages/NotFound';
import LandingPage from './pages/landing-page';
import TermsAndConditions from './pages/terms-and-conditions';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<ProConnectLanding />} />
          <Route path="/landing-page" element={<LandingPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/notfound" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;